module.exports = __webpack_public_path__ + "static/media/style-3.72e9c0ff.svg";